import { api } from '../../App/services/api';
function getLogs(page, rows, period, search, userId) {
    if (page === void 0) { page = 1; }
    if (rows === void 0) { rows = 20; }
    var uri = "/logs?page=".concat(page, "&per_page=").concat(rows);
    if (userId)
        uri += "&user_id=".concat(userId);
    if (search)
        uri += "&search=".concat(encodeURIComponent(search));
    if (period)
        uri += "&period=".concat(encodeURIComponent(period));
    return api.get(uri);
}
function getUsers() {
    return api.get("/logs/users");
}
var logReportService = {
    getLogs: getLogs,
    getUsers: getUsers,
};
export default logReportService;
